<!-- Authored.by.KWShin.2024.01.12. -->
<template>
  <v-menu v-model="showMenu" bottom left transition="slide-y-transition" :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn x-small>
        <v-icon small v-on="on">mdi-cog</v-icon>
      </v-btn>
    </template>
    <template>
      <div class="border-wrap">
        <v-card class="mx-auto" max-width="500">
          <v-list dense>
            <v-list-group v-if="taskTypeOptions.use" no-action eager>
              <template v-slot:activator>
                <v-list-item-title>{{ $t('motlet.taskType') }}</v-list-item-title>
              </template>
              <v-list-item-group v-model="taskTypeData.selected" multiple>
                <v-list-item :value="-1" dense ripple @mousedown.prevent @click="toggleAll('taskType')">
                  <template v-slot:default>
                    <v-list-item-action>
                      <v-icon>{{ iconTaskTypeAll }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('common.select.all') }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
                <v-list-item v-for="(taskType, index) in partialTaskType" :key="index" :value="taskType.value">
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox dense :input-value="active"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ taskType.label }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list-group>
            <v-divider v-if="loadKindOptions.use && loadKindOptions.divider" class="mt-2 mb-2"></v-divider>
            <v-list-group v-if="loadKindOptions.use" no-action eager>
              <template v-slot:activator>
                <v-list-item-title>{{ $t('motlet.loadKind') }}</v-list-item-title>
              </template>
              <v-list-item-group v-model="loadKindData.selected" multiple>
                <v-list-item :value="-1" dense ripple @mousedown.prevent @click="toggleAll('loadKind')">
                  <template v-slot:default>
                    <v-list-item-action>
                      <v-icon>{{ iconLoadKindAll }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('common.select.all') }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
                <v-list-item v-for="(loadKind, index) in codesLoadKind" :key="index" :value="loadKind.value">
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox dense :input-value="active"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ loadKind.label }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list-group>
            <v-divider v-if="logonTypeOptions.use && logonTypeOptions.divider" class="mt-2 mb-2"></v-divider>
            <v-list-group v-if="logonTypeOptions.use" no-action eager>
              <template v-slot:activator>
                <v-list-item-title>{{ $t('motlet.logonType') }}</v-list-item-title>
              </template>
              <v-list-item-group v-model="logonTypeData.selected" multiple>
                <v-list-item :value="-1" dense ripple @mousedown.prevent @click="toggleAll('logonType')">
                  <template v-slot:default>
                    <v-list-item-action>
                      <v-icon>{{ iconLogonTypeAll }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('common.select.all') }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
                <v-list-item v-for="(logonType, index) in codesLogonType" :key="index" :value="logonType.value">
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox dense :input-value="active"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ logonType.label }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list-group>
            <v-divider v-if="yAxisMaxOptions.use && yAxisMaxOptions.divider" class="mt-2 mb-2"></v-divider>
            <v-list-group v-if="yAxisMaxOptions.use" no-action eager id="gear-menu-text-field">
              <template v-slot:activator>
                <v-list-item-title>{{ $t('motlet.yAxisMax') }}</v-list-item-title>
              </template>
              <v-text-field dense solo hide-details readonly :style="{ width: '160px' }" :value="yAxisMaxData.selected | comma">
                <template #prepend>
                  <v-tooltip content-class="tooltip" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn id="minus-btn" class="icon" v-bind="attrs" v-on="on" x-small text @click="onYAxisMinus()">
                        <v-icon>mdi-minus-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('motlet.minus.yaxis') }}</span>
                  </v-tooltip>
                </template>
                <template #append-outer>
                  <v-tooltip content-class="tooltip" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn id="plus-btn" class="icon" v-bind="attrs" v-on="on" x-small text @click="onYAxisPlus()">
                        <v-icon>mdi-plus-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('motlet.plus.yaxis') }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-list-group>
            <v-divider v-if="abapDumpTermOptions.use && abapDumpTermOptions.divider" class="mt-2 mb-2"></v-divider>
            <v-list-group v-if="abapDumpTermOptions.use" no-action eager :style="{ width: '300px' }">
              <template v-slot:activator>
                <v-list-item-title>{{ $t('motlet.abap.dump.term') }}</v-list-item-title>
              </template>
              <v-card id="gear-menu-term">
                <div class="time-area">
                  <div class="print-section">{{ $t('motlet.abap.dump.term.set') }}</div>
                  <div class="time-section d-flex">
                    <v-select v-model="terms[0][0]" :items="termHours" class="time-select" solo dense hide-details :style="{ width: '60px', margin: '0px 6px' }"></v-select>
                    <span class="time-label-span">{{ $t('common.term.hour') }}</span>
                    <v-select v-model="terms[0][1]" :items="termMinutes" class="time-select" solo dense hide-details :style="{ width: '60px', margin: '0px 6px' }"></v-select>
                    <span class="time-label-span">{{ $t('common.term.minute') }}</span>
                    <v-select v-model="terms[0][2]" :items="term30Seconds" class="time-select" solo dense hide-details :style="{ width: '60px', margin: '0px 6px' }"></v-select>
                    <span class="time-label-span">{{ $t('common.term.second') }}</span>
                  </div>
                </div>
              </v-card>
            </v-list-group>
            <v-divider v-if="updRecTermOptions.use && updRecTermOptions.divider" class="mt-2 mb-2"></v-divider>
            <v-list-group v-if="updRecTermOptions.use" no-action eager :style="{ width: '300px' }">
              <template v-slot:activator>
                <v-list-item-title>{{ $t('motlet.upd.rec.term') }}</v-list-item-title>
              </template>
              <v-card id="gear-menu-term">
                <div class="time-area">
                  <div class="print-section">{{ $t('motlet.upd.rec.term.set') }}</div>
                  <div class="time-section d-flex">
                    <v-select v-model="terms[1][0]" :items="termHours" class="time-select" solo dense hide-details :style="{ width: '60px', margin: '0px 6px' }"></v-select>
                    <span class="time-label-span">{{ $t('common.term.hour') }}</span>
                    <v-select v-model="terms[1][1]" :items="termMinutes" class="time-select" solo dense hide-details :style="{ width: '60px', margin: '0px 6px' }"></v-select>
                    <span class="time-label-span">{{ $t('common.term.minute') }}</span>
                    <v-select v-model="terms[1][2]" :items="term15Seconds" class="time-select" solo dense hide-details :style="{ width: '60px', margin: '0px 6px' }"></v-select>
                    <span class="time-label-span">{{ $t('common.term.second') }}</span>
                  </div>
                </div>
              </v-card>
            </v-list-group>
          </v-list>
        </v-card>
      </div>
    </template>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';
import motletable from '@/mixins/motletable';
import { api } from '@/api/common/instances';
import bus from '@/utils/bus';

export default {
  mixins: [motletable],
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showMenu: false,
      // Task Type Data !!
      taskTypeData: {
        previous: [],
        selected: [],
        codes: [],
      },
      // Load Kind Data !!
      loadKindData: {
        previous: [],
        selected: [],
        codes: [],
      },
      // Logon Type Data !!
      logonTypeData: {
        previous: [],
        selected: [],
        codes: [],
      },
      // yAxisMax Data !!
      yAxisMaxData: {
        previous: 0,
        selected: 0,
      },
      // abapDumpTerm Data !!
      abapDumpTermData: {
        previous: 0,
        selected: 0,
      },
      // updRecTerm Data !!
      updRecTermData: {
        previous: 0,
        selected: 0,
      },
      terms: [[], []],
      termHours: this.getTimeUnitValue(25),
      termMinutes: this.getTimeUnitValue(60),
      term30Seconds: ['00', '30'],
      term15Seconds: ['00', '15', '30', '45'],
    };
  },
  computed: {
    ...mapState('common/user', ['username']),
    ...mapState('common/properties', ['partialTaskType', 'codesLoadKind', 'codesLogonType']),
    taskTypeOptions() {
      return this.motletState.taskType ? this.motletState.taskType : { use: false };
    },
    loadKindOptions() {
      return this.motletState.loadKind ? this.motletState.loadKind : { use: false };
    },
    logonTypeOptions() {
      return this.motletState.logonType ? this.motletState.logonType : { use: false };
    },
    yAxisMaxOptions() {
      return this.motletState.yAxisMax ? this.motletState.yAxisMax : { use: false };
    },
    abapDumpTermOptions() {
      return this.motletState.abapDumpTerm ? this.motletState.abapDumpTerm : { use: false };
    },
    updRecTermOptions() {
      return this.motletState.updRecTerm ? this.motletState.updRecTerm : { use: false };
    },
    iconTaskTypeAll() {
      if (this.likesAll('taskType')) return 'mdi-close-box';
      if (this.likesSome('taskType')) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    iconLoadKindAll() {
      if (this.likesAll('loadKind')) return 'mdi-close-box';
      if (this.likesSome('loadKind')) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    iconLogonTypeAll() {
      if (this.likesAll('logonType')) return 'mdi-close-box';
      if (this.likesSome('logonType')) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },
  watch: {
    showMenu(value) {
      if (value) {
        /*
         * 보여지는 싯점에 이 컴포넌트에서 조작할 데이터를 초기화 한다.
         */
        if (this.taskTypeOptions.use) {
          this.taskTypeData.selected = this.taskType ? this.taskType.split(',') : [];
          // 나중에 변경 여부를 판단하기 위해 최초 값을 따로 저장한다.
          this.taskTypeData.previous = this.taskTypeData.selected;
          // store를 통해 DB로부터 prefetch() 해놓은 데이터를 가져와서 value값만 가진 배열로 바꾸어 갖춘다.
          this.taskTypeData.codes = this.partialTaskType.map(elm => elm.value);
        }
        if (this.loadKindOptions.use) {
          this.loadKindData.selected = this.loadKind ? this.loadKind.split(',') : [];
          this.loadKindData.previous = this.loadKindData.selected;
          this.loadKindData.codes = this.codesLoadKind.map(elm => elm.value);
        }
        if (this.logonTypeOptions.use) {
          this.logonTypeData.selected = this.logonType ? this.logonType.split(',') : [];
          this.logonTypeData.previous = this.logonTypeData.selected;
          this.logonTypeData.codes = this.codesLogonType.map(elm => elm.value);
        }
        if (this.yAxisMaxOptions.use) {
          this.yAxisMaxData.selected = this.yAxisMax ? this.yAxisMax : 100;
          this.yAxisMaxData.previous = this.yAxisMaxData.selected;
        }
        if (this.abapDumpTermOptions.use) {
          this.abapDumpTermData.selected = this.abapDumpTerm ? this.abapDumpTerm : 3600;
          this.abapDumpTermData.previous = this.abapDumpTermData.selected;
          this.getTerms(this.terms[0], this.abapDumpTermData.selected);
        }
        if (this.updRecTermOptions.use) {
          this.updRecTermData.selected = this.updRecTerm ? this.updRecTerm : 3600;
          this.updRecTermData.previous = this.updRecTermData.selected;
          this.getTerms(this.terms[1], this.updRecTermData.selected);
        }
      } else {
        /*
         * 감춰지는 싯점에 이 컴포넌트에서 조작한 데이터를 Vuex store에 반영하고,
         * api를 이용하여 서버 DB에도 반영하고,
         * 메인 컴포넌트가 변경된 조건에 따라 데이터를 다시 읽어 올수 있도록 bus에 이벤트를 보낸다.
         */
        if (this.taskTypeOptions.use) {
          // '전체선택' 아이템이 배제된 온전한 코드값 배열을 얻는다.
          const finalTaskType = this.taskTypeData.selected.filter(elm => elm != '-1');
          // 선택이 바뀌었으면...
          if (JSON.stringify(finalTaskType) !== JSON.stringify(this.taskTypeData.previous)) {
            // Vuex store에 반영.
            this.setTaskType(finalTaskType.join(','));
            // 서버 DB에 반영.
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: this.motletId,
                motletProperties: this.taskType,
              })
              .then(() => {
                // Bus에 이벤트 발생.
                bus.$emit(`update:taskType-${this.motletId}`, this.taskType);
              });
          }
        }
        if (this.loadKindOptions.use) {
          const finalLoadKind = this.loadKindData.selected.filter(elm => elm != '-1');
          if (JSON.stringify(finalLoadKind) !== JSON.stringify(this.loadKindData.previous)) {
            this.setLoadKind(finalLoadKind.join(','));
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.motletId}/loadKind`,
                // 여기서 this.loadKind는 애초의 motletOptions.loadKind.selected의 값으로 ','로 분리된 스트링이다.
                motletProperties: this.loadKind,
              })
              .then(() => {
                bus.$emit(`update:loadKind-${this.motletId}`, this.loadKind);
              });
          }
        }
        if (this.logonTypeOptions.use) {
          const finalLogonType = this.logonTypeData.selected.filter(elm => elm != '-1');
          if (JSON.stringify(finalLogonType) !== JSON.stringify(this.logonTypeData.previous)) {
            this.setLogonType(finalLogonType.join(','));
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.motletId}/logonType`,
                // 여기서 this.loadKind는 애초의 motletOptions.logonType.selected의 값으로 ','로 분리된 스트링이다.
                motletProperties: this.logonType,
              })
              .then(() => {
                bus.$emit(`update:logonType-${this.motletId}`, this.logonType);
              });
          }
        }
        if (this.yAxisMaxOptions.use) {
          if (this.yAxisMaxData.selected !== this.yAxisMaxData.previous) {
            this.setYAxisMax(this.yAxisMaxData.selected);
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.motletId}/yAxisMax`,
                motletProperties: this.yAxisMax,
              })
              .then(() => {
                bus.$emit(`update:yAxisMax-${this.motletId}`, this.yAxisMax);
              });
          }
        }
        if (this.abapDumpTermOptions.use) {
          this.abapDumpTermData.selected = parseInt(this.terms[0][0] * 3600);
          this.abapDumpTermData.selected += parseInt(this.terms[0][1] * 60);
          this.abapDumpTermData.selected += parseInt(this.terms[0][2]);
          if (this.abapDumpTermData.selected !== this.abapDumpTermData.previous) {
            this.setAbapDumpTerm(this.abapDumpTermData.selected);
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.motletId}/abapDumpTerm`,
                motletProperties: this.abapDumpTerm,
              })
              .then(() => {
                bus.$emit(`update:abapDumpTerm-${this.motletId}`, this.abapDumpTerm);
              });
          }
        }
        if (this.updRecTermOptions.use) {
          this.updRecTermData.selected = parseInt(this.terms[1][0] * 3600);
          this.updRecTermData.selected += parseInt(this.terms[1][1] * 60);
          this.updRecTermData.selected += parseInt(this.terms[1][2]);
          if (this.updRecTermData.selected !== this.updRecTermData.previous) {
            this.setUpdRecTerm(this.updRecTermData.selected);
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.motletId}/updRecTerm`,
                motletProperties: this.updRecTerm,
              })
              .then(() => {
                bus.$emit(`update:updRecTerm-${this.motletId}`, this.updRecTerm);
              });
          }
        }
      }
    },
  },
  methods: {
    /**
     * "전체선택" 아이템이 클릭되었을 때 처리.
     * 전체가 선택된 상태이면 아무것도 선택 안된 것으로
     * 전제가 선택된 상태가 아니면 전부가 선택된 것으로 바꾸어 준다.
     */
    toggleAll(code) {
      this.$nextTick(() => {
        const codeData = this.getCodeData(code);
        if (this.likesAll(code)) {
          codeData.selected = [];
        } else {
          codeData.selected = codeData.codes.slice();
        }
      });
    },
    /**
     * 전체가 선택된 상태인지 판별한다.
     * 'selected'는 v-list-item-group의 model로 bind되어 있어서
     * '전체선택' 아이템의 값도 포함되므로 그에 대한 처리가 필요하다.
     */
    likesAll(code) {
      const codeData = this.getCodeData(code);
      return codeData.selected.filter(elm => elm != '-1').length === codeData.codes.length;
    },
    /**
     * 일부만 선택된 상태인지 판별한다.
     * 'selected'는 v-list-item-group의 model로 bind되어 있어서
     * '전체선택' 아이템의 값도 포함되므로 그에 대한 처리가 필요하다.
     */
    likesSome(code) {
      const codeData = this.getCodeData(code);
      return codeData.selected.filter(elm => elm != '-1').length > 0;
    },
    /**
     * 패러미터 code의 값에 따라 해당 code 조작에 필요한 data 객체를 판별하여 리턴한다.
     */
    getCodeData(code) {
      switch (code) {
        case 'taskType':
          return this.taskTypeData;
        case 'loadKind':
          return this.loadKindData;
        case 'logonType':
          return this.logonTypeData;
      }
    },
    onYAxisMinus() {
      if (this.yAxisMaxData.selected <= 100) {
        this.$snackbar(this.$t('motlet.info.yaxis.than.100'));
        return;
      }
      this.yAxisMaxData.selected -= 100;
    },
    onYAxisPlus() {
      this.yAxisMaxData.selected += 100;
    },
    getTerms(term, value) {
      let hh, mm, ss;
      if (value) {
        hh = Math.floor(value / 3600);
        mm = Math.floor((value - hh * 3600) / 60);
        ss = value - (hh * 3600 + mm * 60);
        term[0] = hh.toString().padStart(2, '0');
        term[1] = mm.toString().padStart(2, '0');
        term[2] = ss.toString().padStart(2, '0');
      }
    },
    getTimeUnitValue(size) {
      const result = [];
      for (let i = 0; i < size; i++) {
        result.push(i.toString().padStart(2, '0'));
      }
      return result;
    },
  },
};
</script>
<!--
 <style> 섹션에 scoped 속성을 넣으면
 .v-select__selection 처럼 vuetify에 의해 동적으로 적용되는 클래스가 먹질 않는다.
 그래서 scoped를 없애긴 했는데 그렇게 되면 아래의 모든 클래스가 어플리케이션 전역에 적용되게 된다.
 그래서 아래 클래스를 사용하는 요소들의 최상위 요소에 id로 'gear-menu-term'를 부여하고
 그 자식들에게서만 적용되도록 하였다.
 2024.01.17.KWShin.
-->
<!--style scoped-->
<style>
div#gear-menu-term .time-area {
  padding: 9px 12px 9px 5px;
  max-width: 350px;
}
div#gear-menu-term .print-section {
  margin: 0 0 10px 10px;
}
div#gear-menu-term .time-section:not(:last-of-type) {
  margin-bottom: 8px;
}
div#gear-menu-term .time-select {
  margin: 0 3px 0 3px;
}
div#gear-menu-term div.v-select__selection {
  margin: 4px 0px 4px 4px;
}
div#gear-menu-term .time-label-span {
  padding: 4px 0px;
}
/*
div#gear-menu-term div.v-select__selections input {
  width: 0%;
  display: none;
  visibility: hidden;
}
*/
div#gear-menu-term div.v-input__slot {
  padding: 0px 0px 0px 10px;
}
/*
 * 'minus-btn'이라는 id를 가진 button 태그를 가진,
 * 'v-input__prepend-outer'라는 클래스를 가진 div 태그에 
 * CSS를 적용하라! 
 * 젠장... 이렇게 해서 Vuetify component의 slot이 가진
 * 디폴트 스타일을 변경했다.
 * 2024.01.17.KWShin.
*/
div.v-input__prepend-outer:has(button#minus-btn) {
  margin: 2px 0px 0px 10px;
}
div.v-input__append-outer:has(button#plus-btn) {
  margin: 2px 0px 0px 0px;
}
div#gear-menu-text-field div.v-input input {
  text-align: right;
}
</style>
